export default "__VITE_ASSET__CpmJZs6g__"